import { List } from 'immutable';

export function handleMultipleChoiceInput(value, defaultValue, selectedValue, checked, exclusiveChoice) {
  var currentValue = getCurrentValue(value, defaultValue);
  var modifiedValue = currentValue;
  if(exclusiveChoice) {
    modifiedValue = modifiedValue.clear();
    if(!selectedValue)
      return modifiedValue;
  }

  if (checked && !modifiedValue.contains(selectedValue)) {
    return modifiedValue.push(selectedValue)
  }
  if (!checked && modifiedValue.contains(selectedValue)) {
    return modifiedValue.remove(modifiedValue.indexOf(selectedValue));
  }
  return modifiedValue;
}

export function getCurrentValue(value, defaultValue) {
  return value ? value : defaultValue ? defaultValue : List();
}

export function isChecked(value, defaultValue, selectedValue) {
  var currentValue = getCurrentValue(value, defaultValue);
  return !!currentValue && currentValue.indexOf(selectedValue) !== -1;
}
